import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import styles from './AuthorEditorModal.scss'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { CircleSpinner } from 'common/spinners'
import { rideReportActions } from 'data/resources/rideReports'

export const AUTHOR_EDITOR_MODAL = 'AUTHOR_EDITOR_MODAL'

export const _AuthorEditorModal = ({ title, confirmText, onConfirm, loadReport, onRequestClose }) => {
  const [authorByline, setByline] = useState('')
  const [authorUrl, setUrl] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadReport()
      .then(response => {
        const { authorByline, authorUrl } = response.action.payload.rideReport
        setLoading(false)
        setByline(authorByline)
        setUrl(authorUrl)
      })
  }, [])

  const handleConfirm = () => {
    onConfirm(authorByline, authorUrl)
    onRequestClose()
  }

  return (
    <ConfirmationDialog
      title={title}
      maxWidth='600px'
      onRequestClose={onRequestClose}
      confirmText={confirmText}
      onConfirm={handleConfirm}>
      {loading
        ? <CircleSpinner size={40} centered />
        : <div className={styles.content}>
          <div className={styles.formField}>
            <span className={styles.fieldName}>Byline:</span>
            <input
              type='text'
              className={styles.searchInput}
              placeholder={authorByline}
              onChange={e => setByline(e.target.value)}
            />
          </div>
          <div className={styles.formField}>
            <span className={styles.fieldName}>URL (optional):</span>
            <input
              type='text'
              className={styles.searchInput}
              placeholder={authorUrl}
              onChange={e => setUrl(e.target.value)}
            />
          </div>
        </div>
      }
    </ConfirmationDialog>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadReport: () => dispatch(rideReportActions.read(ownProps.reportId))
})

export const AuthorEditorModal = connect(
  null,
  mapDispatchToProps
)(_AuthorEditorModal)
